<template>
    <el-dialog
      title="关联证书"
      width="60%"
      :visible="dialogVisible"
      append-to-body="true"
      @close="$emit('close')">
      <div class="cert-filter">
        <el-row>
          <el-col :span="8">
            <el-input @keyup.enter.native="getList" class="cert-filter-value" placeholder="证书名称" v-model.trim="search.name" size="small" clearable suffix-icon="el-icon-search"></el-input>
          </el-col>
          <el-col :span="8">
            <el-select v-model="search.type" @change="getList" clearable placeholder="选择证书类型" size="small" filterable>
              <el-option
                v-for="(item, index) in certTypeList"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="8">
            <div>
              <el-button class="cert-filter-reset" size="small" @click="getList">立即筛选</el-button>
              <el-button class="cert-filter-search" size="small" @click="searchReset">清除条件</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <avue-crud
        ref="crud"
        :page.sync="page"
        :data="tableData"
        :table-loading="tableLoading"
        :option="option"
        @current-change="currentChange"
        @size-change="sizeChange"
        @selection-change="selectionChange"
        @row-click="rowClick">
  
        <template slot="radio" slot-scope="{row}">
          <el-radio v-model="selectedCertId" :label="row.id"></el-radio>
        </template>
  
        <template slot="name" slot-scope="{row}">
          <div class="name">
            <span class="click" @click="getCertDetail(row.id)">{{row.name}}</span>
          </div>
        </template>
  
      </avue-crud>
      <span class="dialog-footer" slot="footer">
        <el-button @click="$emit('close')">取 消</el-button>
        <el-button type="primary" @click="handleConfirmSelect">确 定</el-button>
      </span>
    </el-dialog>
  </template>
  
  <script>
  import { childCertTypeOptions } from '@/const/crud/cert/cert';
  import { getCertList } from '@/api/cert/cert'
  
  export default {
    name: 'CertSelector',
    props: {
      dialogVisible: {
        type: Boolean,
        required: false,
        default: true,
      },
      selectedCerts: {
        type: Array,
        required: false,
        default: () => [],
      },
    },
    data() {
      return {
        selectedCert: {},
        selectedCertId: {},
        page: {
          total: 0,
          currentPage: 1,
          pageSize: 10,
        },
        tableLoading: false,
        search: {
          name: '',
          type: undefined,
        },
        tableData: [],
        certTypeList: childCertTypeOptions,
        option: {
          tip: false,
          border: true,
          stripe: true,
          menuAlign: 'center',
          align: 'center',
          columnBtn: false,
          refreshBtn: false,
          editBtn: false,
          delBtn: false,
          addBtn: false,
          viewBtn: false,
          menu: false,
          column: [
            {
              label: '',
              prop: 'radio',
              width: 60,
              solt: true,
            },
            {
              label: 'ID',
              prop: 'id',
              width: 100,
              overHidden: true,
            },
            {
              label: '名称',
              prop: 'name',
              overHidden: true,
              solt: true,
            },
            {
              label: '类型',
              prop: 'type',
              dicData: childCertTypeOptions,
            }
          ]
        },
      }
    },
    created() {
      this.getList();
    },
    methods: {
      getCertDetail(id) {
        const routeData =this.$router.resolve({
          path: `/cert/detail/${id}`,
        });
        window.open(routeData.href,'_blank');
      },
      rowClick(row) {
        this.selectedCert = row;
      },
      currentChange(val) {
        this.page.currentPage = val;
        this.getList();
      },
      sizeChange(val) {
        this.page.currentPage = 1;
        this.page.pageSize = val;
        this.getList();
      },
      selectionChange(list){
        this.selectedCerts = list;
      },
      toggleSelection(val){
        this.$refs.crud.toggleSelection(val);
      },
      getList() {
        this.tableLoading = true
        let params = {
          current: this.page.currentPage,
          size: this.page.pageSize,
          name: this.search.name,
          type: this.search.type,
        }
        getCertList(params).then(response => {
          this.tableData = response.data.data.records;
          this.page.total = response.data.data.total;
          this.tableLoading = false;
          const selectedCertIds = this.selectedCerts.map(exam => exam.id);
          this.selectedCerts = this.tableData.filter(exam => {
            return selectedCertIds.includes(exam.id);
          });
          this.$nextTick(() => {
            this.toggleSelection(this.selectedCerts);
          });
        }).catch(error => {
          console.error(error);
          this.$message({
            message: '获取证书列表失败',
            type: 'error'
          });
          this.tableLoading = false;
        })
      },
      searchReset() {
        this.search.name = '';
        this.search.type = undefined;
        this.getList();
      },
      handleConfirmSelect() {
        this.$emit('close');
        this.$emit('confirm-select', this.selectedCert);
      },
    }
  }
  </script>
  
  <style lang="scss" scoped>
  /deep/ thead .el-checkbox {
    display: none;
  }
  
  /deep/ .el-radio__label {
    display: none;
  }
  
  /deep/ .el-radio__inner {
    border: 1px solid #58779b;
  }
  
  /deep/ .avue-crud__menu {
    display: none;
  }
  
  .name {
    display: flex;
    align-items: center;
    color: #606266;
    .cover-image {
      display: flex;
      width: fit-content;
      margin-right: 12px;
      cursor: pointer;
      img {
        width: 40px;
        height: 40px;
        object-fit: cover;
        max-width: 100%;
      }
    }
  }
  .click {
    color:  #5383f3;
    cursor: pointer;
  }
  
  .cert-filter {
    margin: 0 10px;
    border-bottom: 1px solid #ccd0d8;
    /deep/ .el-input__inner {
      font-size: 14px;
    }
    .el-row {
      width: 95%;
    }
    &-label {
      font-size: 14px;
      color: #606266;
      margin-right: 10px;
    }
    &-value {
      width: 96% !important;
    }
    &-search {
      float: right;
      margin-right: 8px;
  
    }
    &-reset {
      float: right;
      margin-right: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }
  </style>
    